var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "np_delete_4642891_000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.902,
    height: 40.496,
    viewBox: "0 0 32.902 40.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M44.668,13.065a3.8,3.8,0,0,0-3.8-3.8H34.545a6.328,6.328,0,1,0-12.656,0H15.563A3.787,3.787,0,0,0,14.3,16.63V36.591a6.855,6.855,0,0,0,6.847,6.847H35.29a6.855,6.855,0,0,0,6.847-6.847V16.63a3.8,3.8,0,0,0,2.531-3.565ZM28.217,5.473a3.8,3.8,0,0,1,3.8,3.8H24.421a3.8,3.8,0,0,1,3.8-3.8ZM39.606,36.59a4.319,4.319,0,0,1-4.316,4.316H21.145a4.319,4.319,0,0,1-4.316-4.316V16.861H39.607Zm1.266-22.26H15.563a1.265,1.265,0,1,1,0-2.53H40.872a1.265,1.265,0,1,1,0,2.53Z",
    transform: "translate(-11.767 -2.942)",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M48.324,60.569A1.265,1.265,0,0,0,49.59,59.3V45.383a1.266,1.266,0,0,0-2.531,0V59.3a1.265,1.265,0,0,0,1.266,1.266Z",
    transform: "translate(-31.873 -26.401)",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M60.09,60.978a1.265,1.265,0,0,0,1.266-1.266V48.324a1.266,1.266,0,0,0-2.531,0V59.713a1.262,1.262,0,0,0,1.266,1.266Z",
    transform: "translate(-38.577 -28.076)",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M36.558,60.978a1.262,1.262,0,0,0,1.266-1.266V48.324a1.266,1.266,0,0,0-2.531,0V59.713a1.265,1.265,0,0,0,1.266,1.266Z",
    transform: "translate(-25.17 -28.076)",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImg);
export default __webpack_public_path__ + "static/media/delete_img.1f36c2f2251d22029d09ae1c468f9d9a.svg";
export { ForwardRef as ReactComponent };